/**
 * React component responsible for rendering the copyright info
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const Copyright = ({ className }) => (
  <h5 className={cx('mb-0', className)}>
    {'© ' + new Date().getFullYear() + ' Propellant, All Rights Reserved.'}
  </h5>
)

Copyright.propTypes = {
  className: PropTypes.string
}

export default Copyright
